angular.module('chat2')
    .directive('conversationMessage', function () {

        var controller = ['$scope','$stateParams', 'sharedDataService', 'sharedChatDataService', 'myProfileService','messageService', 'growlService','comapiChatStore', 'portalConfig',
            function ($scope,$stateParams, sharedDataService, sharedChatDataService, myProfileService, messageService, growlService,comapiChatStore, portalConfig) {

                var userNameCache = {};

                function _getAvatar() {
                    if ($scope.isAgent) {
                        if ($scope.user && $scope.user.avatarUrl && $scope.message.senderId.split('\\')[1] == $scope.user.userName) {
                            return $scope.user.avatarUrl;
                        }
                        return ($scope.message && $scope.message.avatarUrl) ? $scope.message.avatarUrl : $scope.teamAvatar;
                    }

                    return $scope.participantAvatar;
                }

                /** 
                 *
                 */
                $scope.showEllipsis = false;
            
                $scope.messageStatus = function () {
                    var status = "";
                    var platformUsername = "PLATFORMUSER\\" + $scope.user.userName;

                    // Only interested in messages that an agent has sent ...
                    if ($scope.message.senderId.indexOf("PLATFORMUSER\\") === 0 || $scope.message.senderId.indexOf("TEAM\\") === 0 ) {
                        // interested in a status update from the participant

                        if ($scope.message.statusUpdates) {
                            
                            if($scope.message.statusUpdates[sharedChatDataService.participantProfileId]){
                                status = $scope.message.statusUpdates[sharedChatDataService.participantProfileId].status;   
                            }else{ // Are there any statusUpdates of status `failed`

                                let foundFailed = false; 
                                for (let from in $scope.message.statusUpdates) {
                                    let statusUpdate = $scope.message.statusUpdates[from];
                                    if(statusUpdate.status === "failed"){
                                        foundFailed = true;
                                        break;
                                    }
                                }
                                status = foundFailed ? "failed" : "sent";
                            }                                                        
                        }
                        else{
                            status = "sent";
                        }
                    }

                    return status;
                }

                $scope.redactMessage = function(message){
               
                    messageService.redactChatMessage($stateParams.pickedApiSpaceId, message.conversationId, message.id)
                    .then(()=> comapiChatStore.updateMessage(message.conversationId, message.id,[{type: "text/plain", data: portalConfig.redactedMessageData}]))
                    .then(()=> growlService.success("Message was successfully deleted"))
                    .catch(function(){
                        growlService.danger("Message wasn't deleted due to: " + error.statusText);
                    });
                };

                myProfileService.getMyProfile()
                    .then(function (result) {
                        $scope.user = result;

                        $scope.isAgent = $scope.message.senderId.indexOf("PLATFORMUSER") === 0 || $scope.message.senderId.indexOf("TEAM") === 0;
                        $scope.avatar = _getAvatar();
                    });


                /**
                 * 
                 */
                $scope.getUsername = function (senderId) {

                    var userName = userNameCache[senderId];

                    if (userName === undefined) {

                        if (senderId.indexOf("TEAM\\") === 0) {

                            var splitResult = senderId.split("\\");

                            var team = sharedChatDataService.teams ? sharedChatDataService.teams.find(function (t) {
                                return t.id === splitResult[1];
                            }) : undefined;

                            userName = team ? team.name : senderId;
                        } else {
                            var user = sharedDataService.getUsername(senderId.replace("\\", ":"));
                            userName = user;
                        }

                        userNameCache[senderId] = userName;
                    }
                    return userName;
                };

            }];

        return {
            restrict: 'EA',
            scope: {
                // This is the message
                message: '=',
                participantAvatar: "=",
                teamAvatar: "="
            },
            templateUrl: "components/toolkit/chat/templates/conversationMessage.html",
            controller: controller,
        };
    }); 